import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const FleetCarLayout = () => {
  const navList = useNav();
  let {fleetTopHeader, fleetCarBottom} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={fleetCarBottom} topTabs={fleetTopHeader} />
      <Outlet />
    </div>
  )
}

export default FleetCarLayout